import React, { useState, useEffect } from 'react';

const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (navigator.userAgent.includes('ReactSnap')) return; // Отключаем баннер при генерации HTML
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setVisible(true);
    }
  }, []);

  

  const accept = () => {
    localStorage.setItem('cookieConsent', 'true');
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem('cookieConsent', 'false');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.banner}>
        <div style={styles.content}>
          <img src="/images/10.png" alt="Лама" style={styles.icon} />
          <div style={styles.text}>
            <h3 style={styles.title}>Мы используем куки</h3>
            <p style={styles.description}>
              Этот сайт использует куки для аутентификации и улучшения работы. 
              Продолжая использовать сайт, вы соглашаетесь с этим.
            </p>
          </div>
          <div style={styles.buttons}>
            <button onClick={accept} style={styles.acceptBtn}>
              Принять
            </button>
            <button onClick={decline} style={styles.declineBtn}>
              Отклонить
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  overlay: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 10000,
    padding: '16px',
  },
  banner: {
    maxWidth: '800px',
    margin: '0 auto',
    background: 'rgba(255, 255, 255, 0.85)',
    backdropFilter: 'blur(20px)',
    borderRadius: '24px',
    padding: '20px 24px',
    border: '1px solid rgba(168, 85, 247, 0.3)',
    boxShadow: '0 20px 40px rgba(106, 17, 203, 0.15), 0 8px 16px rgba(0, 0, 0, 0.1)',
  },
  content: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    flexWrap: 'wrap',
  },
  icon: {
    width: '48px',
    height: '48px',
    flexShrink: 0,
    borderRadius: '12px',
    objectFit: 'contain',
  },
  text: {
    flex: 1,
    minWidth: '200px',
  },
  title: {
    fontSize: '18px',
    fontWeight: 700,
    color: '#4c1d95',
    margin: '0 0 4px 0',
  },
  description: {
    fontSize: '14px',
    color: '#4b5563',
    margin: 0,
    lineHeight: 1.5,
  },
  buttons: {
    display: 'flex',
    gap: '12px',
    flexShrink: 0,
  },
  acceptBtn: {
    background: 'linear-gradient(135deg, #6a11cb, #2575fc)',
    color: 'white',
    border: 'none',
    padding: '10px 24px',
    borderRadius: '30px',
    cursor: 'pointer',
    fontWeight: 600,
    fontSize: '14px',
    boxShadow: '0 4px 12px rgba(106, 17, 203, 0.3)',
  },
  declineBtn: {
    background: 'rgba(0, 0, 0, 0.05)',
    color: '#6b7280',
    border: '1px solid rgba(0, 0, 0, 0.1)',
    padding: '10px 24px',
    borderRadius: '30px',
    cursor: 'pointer',
    fontWeight: 500,
    fontSize: '14px',
  },
};

export default CookieConsent;
